import { useGlobal } from '@/utils/useGlobal';
import EfVideo from '@elem/ui/ef-video';
import styles from './index.module.scss';

const Closer = () => {
    const { useLang } = useGlobal();
    const { t } = useLang('OceanProHomeSolarBattery');

    const list = [
        {
            title: t(`closer_sec1_title`),
            desc: t(`closer_sec1_desc`),
            percent: t(`closer_sec1_percent`),
            video: 'https://websiteoss.ecoflow.com/upload/video/1752050037240/Closer1.mp4',
            poster: 'https://websiteoss.ecoflow.com/upload/image/1760325455143/Closer1.jpg',
        },
        {
            title: t(`closer_sec2_title`),
            desc: t(`closer_sec2_desc`),
            percent: t(`closer_sec2_percent`),
            video: 'https://websiteoss.ecoflow.com/upload/video/1752050037396/Closer2.mp4',
            poster: 'https://websiteoss.ecoflow.com/upload/image/1760325454422/Closer2.jpg',
        },
        {
            title: t(`closer_sec3_title`),
            desc: t(`closer_sec3_desc`),
            percent: t(`closer_sec3_percent`),
            video: 'https://websiteoss.ecoflow.com/upload/video/1751439518797/Closer3.mp4',
            poster: 'https://websiteoss.ecoflow.com/upload/image/1760325455417/Closer3.jpg',
        },
    ];

    return (
        <div className={`${styles.closer} GtmModuleData-section`} data-section-id={styles.closer} data-section-title={t(`closer_title`)}>
            <div className="text-container">
                <h2>
                    {t.rich('closer_title', {
                        tag: (text: string) => <span className="tag">{text}</span>,
                    })}
                </h2>
                {/* <h2>{t(`closer_title`)}</h2> */}
                <p className="intro">
                    {t.rich('closer_intro', {
                        sup: (text: string) => <sup>{text}</sup>,
                    })}
                </p>
            </div>
            <div className="content">
                {list.map((item) => (
                    <div key={item.title} className="item">
                        <div className="text-wrapper">
                            <h3>{item.title}</h3>
                            <p>{item.desc}</p>
                            <span>{item.percent}</span>
                        </div>
                        <div className="video-wrapper">
                            <EfVideo pc={item.video} poster={item.poster} className="video" autoPlay loop />
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Closer;
